<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12>
        <div>
          <v-dialog v-model="dialog" max-width="500px">
            <div slot="activator">
              <v-tooltip right>
                <v-btn fab large color="primary darken-1" dark slot="activator" class="elevation-10">
                  <v-icon>add</v-icon>
                </v-btn>
                <span>Add a new layout</span>
              </v-tooltip>
            </div>

            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12>
                      <v-text-field prepend-icon="view_column" label="Name" name="name" v-model="editedItem.name"
                                    :error-messages="form.errors.has('name') ? form.errors.get('name') : []"
                                    @keypress="form.errors.clear('name')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-select
                        :items="layoutTypes" v-model="editedItem.type" item-text="text"
                        label="Layout Type" name="type" prepend-icon="account_balance"
                        auto :disabled="editedIndex !== -1"
                        :error-messages="form.errors.has('type') ? form.errors.get('type') : []"
                        @change="form.errors.clear('type')"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <v-textarea
                        outline
                        rows="3"
                        label="Description"
                        name="description"
                        v-model="editedItem.description"
                        :error-messages="form.errors.has('description') ? form.errors.get('description') : []"
                        @keypress="form.errors.clear('description')"
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary darken-1" flat @click.native="close">
                  <v-icon left dark>arrow_back</v-icon>
                  Cancel
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary darken-1" @click.native="save" :loading="formLoading">
                  <v-icon left dark>save</v-icon>
                  Save
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </v-flex>
    </v-layout>

    <!-- seats layout -->
    <v-dialog v-model="seatsDialog" persistent fullscreen scrollable>
      <v-card>
        <v-toolbar card dark color="primary">
          <v-btn icon @click.native="closeLayoutDesigner" dark>
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ slotsLayoutName }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click.native="saveDesign">Save <v-icon right dark>save</v-icon></v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text ref="canvasContainer"
                     :style="{ 'height': cContainerHeight + 'px' }"
        >
          <!--<c-slots :selected-layout="selectedLayout"></c-slots>-->
          <c-floor-plan-designer :canvas-width="canvasWidth"
                                 :canvas-height="canvasHeight"
                                 :selected-layout="selectedLayout"
                                 :trigger-save="triggerSaveDesign"
                                 :designer-modal-closed="!seatsDialog"
                                 @layout-components-saved="closeSeatsDialog($event)"
                                 @reset-save-btn="resetSaveBtn"
          ></c-floor-plan-designer>
        </v-card-text>
        <v-card-actions>
          <!--<v-spacer></v-spacer>-->
          <!--<v-btn color="primary darken-1" dark @click.native="seatsDialog = false">-->
          <!--<v-icon left>save</v-icon>-->
          <!--Save-->
          <!--</v-btn>-->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end seats layout -->

    <!-- layouts data table -->
    <v-card class="elevation-5">
      <v-card-title>
        <span class="headline">Layouts</span>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Search"
          single-line
          hide-details
          v-model="search"
          @keyup.enter="searchLayouts"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="layouts"
        :pagination.sync="pagination"
        :total-items="totalLayouts"
        :rows-per-page-items="rowsPerPageItems"
        :loading="tableLoading"
        :must-sort="true"
      > <!-- :search="search" -->
        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.id }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.type }}</td> <!-- class="text-xs-center" -->
          <td>{{ props.item.description }}</td>
          <td class="justify-center layout px-0">

            <v-layout row justify-center> <!-- v-if="props.item.type === 'CINEMA'" -->
              <div slot="activator">
                <v-tooltip top>
                  <v-btn icon class="mx-0" slot="activator" @click="showSeatsPreview(props.item)">
                    <v-icon color="primary">event_seat</v-icon>
                  </v-btn>
                  <span>Seats preview</span>
                </v-tooltip>
              </div>
            </v-layout>

            <v-tooltip top>
              <v-btn icon class="mx-0" @click="editItem(props.item)" slot="activator">
                <v-icon color="teal">edit</v-icon>
              </v-btn>
              <span>Edit</span>
            </v-tooltip>
            <v-tooltip top>
              <v-btn icon class="mx-0" @click="deleteItem(props.item)" slot="activator">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
              <span>Delete</span>
            </v-tooltip>
          </td>
        </template>
        <template v-if="noResourcesFound" slot="no-data">
          <v-alert :value="true" color="error" icon="warning">
            Sorry, no layouts found please start by adding some layouts
          </v-alert>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
    <!-- end layout data table -->

    <v-snackbar
      :timeout="snackbarTimeout"
      :color="snackbarColor"
      v-model="snackbar"
      top
    >
      {{ snackbarText }}
      <v-btn dark flat @click.native="snackbar = false"><v-icon color="black">close</v-icon></v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  import {mapActions} from 'vuex';

  export default {
    name: "Layouts",

    props: {
      // resourceId: String
    },

    data: () => ({
      search: '',
      noResourcesFound: false,
      seatsDialog: false,
      bookingDialog: false,
      slotsLayoutName: '',
      selectedLayout: null,
      cContainerHeight: 0,
      canvasWidth: 11000,
      canvasHeight: 11000,
      triggerSaveDesign: false,
      headers: [
        { text: '#', value: 'id' },
        { text: 'Name', value: 'name' },
        { text: 'Layout Type', value: 'type', align: 'left' },
        { text: 'Description', value: 'description' },
        { text: 'Actions', value: 'profile.first_name', sortable: false, width: '5px', align: 'center' }
      ],
      layouts: [],
      totalLayouts: 0,
      pagination: {
        descending: true
      },
      rowsPerPageItems: [100, 50, 25],
      layoutTypes: [ 'CINEMA', 'GUESTHOUSE', 'GYM', 'TRAINING_ROOM' ],
      tableLoading: true,
      editedIndex: -1,
      dialog: false,
      formLoading: false,
      snackbar: false,
      snackbarColor: '',
      snackbarMode: '',
      snackbarTimeout: 6000,
      snackbarText: '',
      editedItem: {
        name: '',
        type: '',
        description: ''
      },
      defaultItem: {
        name: '',
        type: '',
        description: ''
      },
      form: new Form({
        name: '',
        type: '',
        description: ''
      }),
      searchMode: false
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Layout' : 'Edit Layout';
      }
    },

    watch: {
      dialog (val) {
        val || this.close();
      },
      pagination: {
        handler () {
          this.getLayouts();
        },
        deep: true
      },
      search (val) {
        // console.log("MATCH SEQ = ", val);
        this.searchMode = !(val = "");
      }
    },

    created() {
      this.setActiveMenu('Layouts');
      this.setActiveSubmenu('All Layouts');
      this.getLayouts();
    },

    mounted() {
      this.cContainerHeight = window.innerHeight;
    },

    methods: {
      /* Search layouts */
      searchLayouts() {
        this.tableLoading = true;
        this.pagination.page = 1;
        this.getLayouts();
      },

      /* Fetch list of all layouts from the server */
      getLayouts() {
        let page = this.pagination.page - 1;
        let size = this.pagination.rowsPerPage;
        let sortBy = this.pagination.sortBy;
        let descending = this.pagination.descending;
        if (page >= 0) {
          this.tableLoading = true;
          let url = '';
          if (this.searchMode) {
            url = BACKEND_URL + '/api/paginated-layouts/search' + '?match_seq=' + this.search + '&page=' + page + '&size=' + size + '&sort_by=' + sortBy + '&desc=' + descending;
          } else
            url = BACKEND_URL + '/api/paginated-layouts' + '?page=' + page + '&size=' + size + '&sort_by=' + sortBy + '&desc=' + descending;
          axios.get(url).then(({data}) => {

            this.layouts = (data && data.content && data.content.length > 0) ? data.content : [];
            this.totalLayouts = (data && data.totalElements >= 0) ? data.totalElements : 0;

            if (!this.layouts.length > 0) {
              this.noResourcesFound = true;
            }
            this.tableLoading = false;
            // console.log('ANALYSE THIS:', data);
            // console.log('ANALYSE THIS:', this.pagination);
          }).catch((error) => {
            this.tableLoading = false;
            if (error.message === 'Network Error') {
              console.log('Cannot connect to server');
            } else {
              console.log(error.response.data);
            }
          });
        }
      },

      /* Pass the selected item to the edit dialog and show the dialog */
      editItem (item) {
        this.editedIndex = this.layouts.indexOf(item);
        this.editedItem = Object.assign({}, item);

        this.dialog = true;
      },

      /* Scroll to the middle of the canvas */
      scrollToCenter() {
        this.$refs.canvasContainer.scrollTop = (this.canvasHeight / 2) - ((window.innerHeight / 2) - 20);
        this.$refs.canvasContainer.scrollLeft = (this.canvasWidth / 2) - ((window.innerWidth / 2) - 20);
      },

      /* Delete an item */
      deleteItem (item) {
        const index = this.layouts.indexOf(item);
        var prompt = confirm("Are you sure you want to permanently delete this layout from the database? \nThis action cannot be undone.");
        if (prompt === true) {
          axios.delete(BACKEND_URL+'/api/layouts/' + item.id).then(({data})=>{
            this.layouts.splice(index, 1);
            this.totalLayouts -= 1;
            console.log(data);
          }).catch((error)=>{
            console.log(error.response.data);
          });
        }
      },

      /* Set the resource and layout name on the seats preview dialog */
      showSeatsPreview(item) {
        this.slotsLayoutName = item.name;
        this.selectedLayout = item;
        this.editedIndex = this.layouts.indexOf(item);

        this.seatsDialog = true;

        setTimeout(() => {
          this.scrollToCenter();
        }, 300);
      },

      /* Reset the new/edit dialog form when it closes */
      close () {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      /* Save/edit dialogue form content */
      save () {
        this.formLoading = true;

        this.form.name = this.editedItem.name;
        this.form.type = this.editedItem.type;
        this.form.description = this.editedItem.description;

        if (this.editedIndex > -1) {
          this.form.id = this.editedItem.id;
          // console.log(this.form);

          this.form.put(BACKEND_URL+'/api/layouts/'+this.editedItem.id).then(({data}) => {
            console.log(data);
            Object.assign(this.layouts[this.editedIndex], data);

            this.formLoading = false;
            this.close();
            this.showSnackbar('success', 'Layout details successfully updated!');
          }).catch((error) => {
            console.log(error);
            this.formLoading = false;
          });
        } else {
          // console.log(this.form);
          this.form.post(BACKEND_URL+'/api/layouts').then(({data}) => {
            console.log(data);
            this.layouts.unshift(data);
            this.totalLayouts += 1;

            this.formLoading = false;
            this.close();
            this.showSnackbar('success', 'The layout has been successfully created!');
          }).catch(error => {
            console.log(error);
            this.formLoading = false;
          });
        }
      },

      /* Trigger the save design process */
      saveDesign() {
        // console.log('gets here');
        this.triggerSaveDesign = true;
      },

      /* Close the seats layout designer dialog */
      closeSeatsDialog(layout) {
        Object.assign(this.layouts[this.editedIndex], layout);
        this.closeLayoutDesigner();
      },

      /* Reset the save btn */
      resetSaveBtn() {
        this.triggerSaveDesign = false;
      },

      /* Close the seats layout designer */
      closeLayoutDesigner () {
        this.seatsDialog = false;

        this.selectedLayout = null;
        this.editedIndex = -1;
        this.resetSaveBtn();
      },

      showSnackbar(snackbarColor, snackbarText) {
        this.snackbarColor = snackbarColor;
        this.snackbarText = snackbarText;
        this.snackbar = true;
      },

      navigateTo(path) {
        this.$router.push(path);
      },

      /* map vuex actions */
      ...mapActions([
        'setActiveMenu',
        'setActiveSubmenu'
      ])
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/layout/Layouts.vue